import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { bodyTextProps, formatPart2Date, Part2Appointment } from '../utils';
import { NachversandCard } from './NachversandCard';
import { Part2AppointmentDetails } from './Part2AppointmentDetails';
import { Part2BookingButton } from './Part2BookingButton';

export const MissedCard = ({
  appointment,
}: {
  appointment: Part2Appointment;
}) => {
  const { t } = useTranslation('versand');

  return (
    <NachversandCard title={t('Missed.Title')} warning>
      <Text {...bodyTextProps}>
        {t('Missed.Description', {
          date: formatPart2Date(appointment.startTime),
        })}
      </Text>
      <Part2AppointmentDetails
        appointment={appointment}
        withBringAlong={false}
      />
      <Part2BookingButton label={t('Missed.Button')} />
    </NachversandCard>
  );
};
